import { WebApiService } from '../../plugins/webApiService'
import { Events } from '../../plugins/events'
import { SendRequestModel } from '../../plugins/models/SendRequestModel'
import YearRequest from '../../working-calendar/i-service/models/request/YearRequest';
import RemoveCalendarRequest from '../../users/base/i-service/models/requests/RemoveCalendarRequest';
import AddOrEditDayRequest from '../../working-calendar/i-service/models/request/AddOrEditDayRequest';
import SearchDaysRequest from '../../working-calendar/i-service/models/request/SearchDaysRequest';
import RemoveDayRequest from '../../working-calendar/i-service/models/request/RemoveDayRequest';
import WsResponseModelT from '../../schema-builder-server/models/WsResponseModelT';
import DaysResponse from '../../working-calendar/i-service/models/response/DaysResponse';

export default class WorkingCalendarService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	CreateWorkingCalendarEvent = new Events<WsResponseModelT<number>>();
	RemoveCalendarEvent = new Events<WsResponseModelT<Boolean>>();
	GetYearsEvent = new Events<WsResponseModelT<Array<number>>>();
	GetDayEvent = new Events<WsResponseModelT<Array<DaysResponse>>>();
	AddOrEditDayEvent = new Events<WsResponseModelT<DaysResponse>>();
	SearchEvent = new Events<WsResponseModelT<Array<DaysResponse>>>();
	RemoveDayEvent = new Events<WsResponseModelT<Boolean>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('WorkingCalendarService', 'CreateWorkingCalendar', 'Main', (res: WsResponseModelT<number>) => {
			self.CreateWorkingCalendarEvent.trigger(res);
		});
		webApiService.on('WorkingCalendarService', 'RemoveCalendar', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveCalendarEvent.trigger(res);
		});
		webApiService.on('WorkingCalendarService', 'GetYears', 'Main', (res: WsResponseModelT<Array<number>>) => {
			self.GetYearsEvent.trigger(res);
		});
		webApiService.on('WorkingCalendarService', 'GetDay', 'Main', (res: WsResponseModelT<Array<DaysResponse>>) => {
			self.GetDayEvent.trigger(res);
		});
		webApiService.on('WorkingCalendarService', 'AddOrEditDay', 'Main', (res: WsResponseModelT<DaysResponse>) => {
			self.AddOrEditDayEvent.trigger(res);
		});
		webApiService.on('WorkingCalendarService', 'Search', 'Main', (res: WsResponseModelT<Array<DaysResponse>>) => {
			self.SearchEvent.trigger(res);
		});
		webApiService.on('WorkingCalendarService', 'RemoveDay', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveDayEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Создание  календаря
	 */
	async CreateWorkingCalendar(request: YearRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'WorkingCalendarService',
			Method: 'CreateWorkingCalendar',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление календаря
	 */
	async RemoveCalendar(request: RemoveCalendarRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'WorkingCalendarService',
			Method: 'RemoveCalendar',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Список годов которые есть
	 */
	async GetYears() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'WorkingCalendarService',
			Method: 'GetYears',
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Ролучения календаря
	 */
	async GetDay(request: YearRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'WorkingCalendarService',
			Method: 'GetDay',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавление или редактирование производстьвенного дня
	 */
	async AddOrEditDay(request: AddOrEditDayRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'WorkingCalendarService',
			Method: 'AddOrEditDay',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Поиск событий
	 */
	async Search(request: SearchDaysRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'WorkingCalendarService',
			Method: 'Search',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаления дня
	 */
	async RemoveDay(request: RemoveDayRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'WorkingCalendarService',
			Method: 'RemoveDay',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Создание  календаря
	 */
	async createWorkingCalendarAsync(request: YearRequest): Promise<number> {
		return new Promise<number>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'WorkingCalendarService',
				Method: 'CreateWorkingCalendar',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<number>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as number)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление календаря
	 */
	async removeCalendarAsync(request: RemoveCalendarRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'WorkingCalendarService',
				Method: 'RemoveCalendar',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Список годов которые есть
	 */
	async getYearsAsync(): Promise<Array<number>> {
		return new Promise<Array<number>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'WorkingCalendarService',
				Method: 'GetYears',
				Callback: (response: WsResponseModelT<Array<number>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<number>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Ролучения календаря
	 */
	async getDayAsync(request: YearRequest): Promise<Array<DaysResponse>> {
		return new Promise<Array<DaysResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'WorkingCalendarService',
				Method: 'GetDay',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Array<DaysResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<DaysResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавление или редактирование производстьвенного дня
	 */
	async addOrEditDayAsync(request: AddOrEditDayRequest): Promise<DaysResponse> {
		return new Promise<DaysResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'WorkingCalendarService',
				Method: 'AddOrEditDay',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<DaysResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as DaysResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Поиск событий
	 */
	async searchAsync(request: SearchDaysRequest): Promise<Array<DaysResponse>> {
		return new Promise<Array<DaysResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'WorkingCalendarService',
				Method: 'Search',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Array<DaysResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<DaysResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаления дня
	 */
	async removeDayAsync(request: RemoveDayRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'WorkingCalendarService',
				Method: 'RemoveDay',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}